import { Icon } from '@components/primitives/Icon'
import { Text } from '@components/primitives/Text'
import { type IconDefinition } from '@fortawesome/pro-regular-svg-icons'
import type { ReactNode } from 'react'

export const TrialApplyStartValueProp = ({
  icon,
  subtitle,
  title,
}: {
  icon: IconDefinition
  subtitle: ReactNode
  title: string
}) => {
  return (
    <div className='flex flex-row items-start justify-center gap-4'>
      <div className='w-10 text-center'>
        <Icon className='text-blue600' icon={icon} size='2x' />
      </div>
      <div className='w-5/6 text-left'>
        <Text className='text-lg font-bold' value={title} />
        <Text className='text-neutral600' value={subtitle} />
      </div>
    </div>
  )
}
